import { PrintableEvent } from "@mcleod/components";
import { AutogenLayoutRmSpCities } from "./autogen/AutogenLayoutRmSpCities";

export class RmSpCities extends AutogenLayoutRmSpCities {

    textboxDistanceOnPrintable(event: PrintableEvent) {
        const textbox = event.target;
        textbox.fillRow = true;
    }

}
